var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M96.616,73.1h3.36v6.02h-3.36Zm13.33-8.17v37.45a4.156,4.156,0,0,1-1.26,2.99,4.09,4.09,0,0,1-3.02,1.28H68.216a4.393,4.393,0,0,1-4.27-4.27V64.93a4.062,4.062,0,0,1,1.29-3.02,4.117,4.117,0,0,1,2.98-1.26h37.45a4.3,4.3,0,0,1,4.28,4.28M98.886,95.76H74.316v3h24.57Zm4.09-22.66a3,3,0,0,0-3-3H74.316V87.58a5.894,5.894,0,0,0,1.81,4.37,6.044,6.044,0,0,0,4.4,1.78h9.86a6.083,6.083,0,0,0,4.41-1.78,5.9,5.9,0,0,0,1.82-4.37V82.1h3.36a2.877,2.877,0,0,0,2.12-.88,2.833,2.833,0,0,0,.88-2.1Z",
    transform: "translate(-63.946 -60.65)",
    fill: "var(--primary-color)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.4a0bd95d26c0bfebb20849a24e4a0066.svg";
export { ForwardRef as ReactComponent };